var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V20H1.45248V13.7102L14.4567 7.86808L16 7.18492L14.4567 6.50177L1.02128 0.471143L0 0ZM1.45248 2.28504L12.3461 7.18492L1.45248 12.0848V2.28504Z",
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostReport);
export default __webpack_public_path__ + "static/media/post_report.935a47c25be51ed7be128c4b29b0d68b.svg";
export { ForwardRef as ReactComponent };